import { DropdownPopper } from './DropdownPopper';

// TODO: in v9, move styled() from DropdownPopper.jsx to here
export var StyledDropdownPopper = DropdownPopper;